<template>
  <div>
    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="jingchuData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">

          <el-table-column  prop="tid" label="用户订单号" width="180px"></el-table-column>
          <el-table-column  prop="comp" label="收件公司" width="100px"></el-table-column>
          <el-table-column  prop="maskName" label="联系人" width="120px"></el-table-column>
          <el-table-column  prop="maskPhone" label="联系电话" width="120px"></el-table-column>
          <el-table-column  prop="maskMobile" label="手机号码" width="120px"></el-table-column>
          <el-table-column  prop="addr" label="收件详细地址" width="240px"></el-table-column>
          <el-table-column  prop="receiverState" label="省份" ></el-table-column>
          <el-table-column  prop="buyerAlipayNo" label="支付宝账号" ></el-table-column>
          <el-table-column  prop="paytype" label="付款方式" ></el-table-column>
          <el-table-column  prop="cardno" label="第三方付月结卡号" ></el-table-column>
          <el-table-column  prop="title" label="托寄物物内容" width="200px"></el-table-column>
          <el-table-column  prop="num" label="托寄物物数量" width="60px"></el-table-column>
          <el-table-column  prop="cnt" label="件数" width="60px"></el-table-column>
          <el-table-column  prop="" label="实际重量(KG)" ></el-table-column>
          <el-table-column  prop="" label="计费重量(KG)" ></el-table-column>
          <el-table-column  prop="express" label="业务类型" ></el-table-column>
          <el-table-column  prop="address" label="是否电商加急"  width=""></el-table-column>
          <el-table-column  prop="" label="是否代收货款" ></el-table-column>
          <el-table-column  prop="ds" label="代收货款金额" ></el-table-column>
          <el-table-column  prop="" label="是否保价" ></el-table-column>
          <el-table-column  prop="" label="包装费(元)" ></el-table-column>
          <el-table-column  prop="" label="其他费用(元)" ></el-table-column>
          <el-table-column  prop="" label="是否自取" ></el-table-column>
          <el-table-column  prop="" label="是否签回单" ></el-table-column>
          <el-table-column  prop="" label="是否定时派送" ></el-table-column>
          <el-table-column  prop="" label="派送日期" ></el-table-column>
          <el-table-column  prop="" label="派送时段" ></el-table-column>
          <el-table-column  prop="" label="是否电子验收" ></el-table-column>
          <el-table-column  prop="" label="是否保单配送" ></el-table-column>
          <el-table-column  prop="" label="是否拍照验证" ></el-table-column>
          <el-table-column  prop="" label="是否保鲜服务" ></el-table-column>
          <el-table-column  prop="" label="是否易碎件" ></el-table-column>
          <el-table-column  prop="" label="收件员" ></el-table-column>
          <el-table-column  prop="" label="寄方签名" ></el-table-column>
          <el-table-column  prop="" label="寄件日期" ></el-table-column>
          <el-table-column  prop="" label="签收短信通知(MSG)" width="100px"></el-table-column>
          <el-table-column  prop="" label="派件短信通知(SMS)"  width="100px"></el-table-column>
          <el-table-column  prop="memo" label="寄方客户备注" width="240px"></el-table-column>
          <el-table-column  prop="" label="长(cm)" ></el-table-column>
          <el-table-column  prop="buyerMessage" label="宽(cm)" ></el-table-column>
          <el-table-column  prop="sellerMemo" label="高(cm)" ></el-table-column>
          <el-table-column  prop="postFee" label="邮费" ></el-table-column>
          <el-table-column  prop="discountFee" label="优惠" ></el-table-column>
          <el-table-column  prop="payment" label="订单总价" ></el-table-column>
          <el-table-column  prop="maskNick" label="扩展字段1" width="120px"></el-table-column>
          <el-table-column  prop="created" label="扩展字段2"  width="160px"></el-table-column>
          <el-table-column  prop="payTime" label="扩展字段3"  width="160px"></el-table-column>

        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "JingChu",
    data() {
      return {
        display:1,
        jingchuData:[],
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 10
        },
      }
    },
    methods:{
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
        }

      },
      indexMethod(index)
      {
        return index + 1;
      },
      getJingchuData:function () {
        let param={
          nick: storage.get("nick")
        }
        $api.post("/custom/jingchu",param, response=>{
          let dataResult = response.data;

          if(dataResult.state == 1 && dataResult.message=="ok"){
            this.jingchuData = dataResult.data.jingchu;
            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }else{
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }
        })
      }
    },
    mounted(){
      this.getJingchuData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/JingChu.vue